module.exports = __webpack_public_path__ + "static/img/appStore.5318e2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/footer/appStore.svg
// module id = 1816
// module chunks = 1